export default "__VITE_ASSET__C4xnic8e__"